import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { I18n } from 'react-i18next'
import DatePicker from '../../../../components/Calendar/DatePicker'
import { toggleCalendar } from '../../actions'
import { getModule, getLanguage, getDatePickerOpened } from '../../selectors'

// binding for redux-form
const VisualComponent = ({
    input: { value, onChange },
    path,
    open,
    onOpenChange,
    language,
    module,
    defaultCalendarValue
}) => {
    return (
        <I18n ns={[module.model, 'platform']}>
            {t => (
                <DatePicker
                    path={path}
                    value={value}
                    open={open}
                    onChange={value => onChange(value)}
                    onOpenChange={onOpenChange}
                    language={language}
                    placeholder={t('pickDate')}
                    defaultCalendarValue={defaultCalendarValue}
                />
            )}
        </I18n>
    )
}

const DatePickerComponent = ({
    filter,
    open,
    language,
    module,
    toggleCalendar,
    onChange,
    fetchFilterData
}) => {
    const fieldName = filter.path
    return (
        <Field
            name={fieldName}
            path={filter.tKey || filter.path}
            component={VisualComponent}
            onChange={(event, value) => {
                // we need to call fetchDtData after reduxFormChange
                event.preventDefault()
                onChange(fieldName, value)
                fetchFilterData()
            }}
            open={open}
            language={language}
            module={module}
            onOpenChange={() => toggleCalendar(filter.id)}
            defaultCalendarValue={filter.defaultCalendarValue}
        />
    )
}

const mapStateToProps = (state, { filter }) => ({
    open: getDatePickerOpened(state, filter.id),
    language: getLanguage(state),
    module: getModule
})

const mapDispatchToProps = dispatch => ({
    toggleCalendar: filterId => dispatch(toggleCalendar(filterId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DatePickerComponent)
